<template>
	<div id="main" class="column is-9">
		<div class="columns">
			<div class="column">
				<div class="card">
					<div class="tags is-pulled-right">
						<span class="tag is-light" v-if="status === 'Draft'">Draft</span>
						<span class="tag is-warning" v-if="status === 'Pending'">Pending</span>
						<span class="tag is-success" v-if="status === 'Approved'">Approved</span>
					</div>
					<header class="card-header">
						<p class="card-header-title">
							Listing
						</p>
					</header>
					<div class="card-table">
						<div class="content">
							<div class="columns">
								<div class="column">
									<form>
										<label class="label">Categories</label>
										<p>
											Select up to 5 categories to feature your listing in.
										</p>
										<div class="field is-narrow categories">
											<div class="control">
												<label class="checkbox is-small">
												<input type="checkbox" 
													:disabled="status == 'Pending'"
													:value="26"
													@click="addCategory"
													:checked="listing.categories.includes(26)"> Love &amp; Relationships</label>
											</div>
											<div class="control">
												<label class="checkbox is-small">
												<input type="checkbox" 
													:disabled="status == 'Pending'"
													:value="27"
													@click="addCategory"
													:checked="listing.categories.includes(27)"> Money &amp; Finance</label>
											</div>
											<div class="control">
												<label class="checkbox is-small">
												<input type="checkbox" 
													:disabled="status == 'Pending'"
													:value="28"
													@click="addCategory"
													:checked="listing.categories.includes(28)">
												Careers &amp; Goals</label>
											</div>
											<div class="control">
												<label class="checkbox is-small">
												<input type="checkbox" 
													:disabled="status == 'Pending'"
													:value="25"
													@click="addCategory"
													:checked="listing.categories.includes(25)"> Tarot Readers</label>
											</div>
											<div class="control">
												<label class="checkbox is-small">
												<input type="checkbox" 
													:disabled="status == 'Pending'"
													:value="31"
													@click="addCategory"
													:checked="listing.categories.includes(31)"> Spiritual Guides</label>
											</div>
											<div class="control">
												<label class="checkbox is-small">
												<input type="checkbox" 
													:disabled="status == 'Pending'"
													:value="13"
													@click="addCategory"
													:checked="listing.categories.includes(13)"> Numerology</label>
											</div>
											<div class="control">
												<label class="checkbox is-small">
												<input type="checkbox" 
													:disabled="status == 'Pending'"
													:value="30"
													@click="addCategory"
													:checked="listing.categories.includes(30)"> Astrology Readings</label>
											</div>
											<div class="control">
												<label class="checkbox is-small">
												<input type="checkbox" 
													:disabled="status == 'Pending'"
													:value="29"
													@click="addCategory"
													:checked="listing.categories.includes(29)"> Past Lives</label>
											</div>
											<div class="control">
												<label class="checkbox is-small">
												<input type="checkbox" 
													:disabled="status == 'Pending'"
													:value="32"
													@click="addCategory"
													:checked="listing.categories.includes(32)"> Dream Analysis</label>
											</div>
											<div class="control">
												<label class="checkbox is-small">
												<input type="checkbox" 
													:disabled="status == 'Pending'"
													:value="128"
													@click="addCategory"
													:checked="listing.categories.includes(128)"> Mediums</label>
											</div>
											<div class="control">
												<label class="checkbox is-small">
												<input type="checkbox" 
													:disabled="status == 'Pending'"
													:value="82"
													@click="addCategory"
													:checked="listing.categories.includes(82)"> En Español</label>
											</div>
										</div>
										<p class="help is-danger" v-if="errors.categories">{{ errors.categories }}</p>
										<label class="label">Sales Pitch:</label>
										<div class="field">
											<div class="control">
												<textarea class="textarea" :class="{'is-danger': errors.sales_pitch}" placeholder="" rows="4" v-model="listing.sales_pitch" :disabled="status == 'Pending'"></textarea>
											</div>
										</div>
										<p class="help is-danger" v-if="errors.sales_pitch">{{ errors.sales_pitch }}</p>
										<label class="label">Bio Text:</label>
										<div class="field">
											<div class="control">
												<textarea class="textarea" :class="{'is-danger': errors.body}" placeholder="" rows="15" v-model="cleanBody" :disabled="status == 'Pending'"></textarea>
											</div>
										</div>
										<p class="help is-danger" v-if="errors.body">{{ errors.body }}</p>
										<div class="field is-grouped">
											<div class="control">
												<a @click="toggleModal('Are you sure you want to submit this listing for approval? You won\'t be able to make changes while your listing is pending approval.', submitForApproval)" class="button is-small is-primary">
												Submit for Approval</a>
											</div>
											<div class="control">
												<a onclick="" class="button is-small">
												Reset</a>
											</div>
										</div>
									</form>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<Modal v-if="rejectedShown == true" @close="rejectedShown = false">
			<span slot="title">LISTING REJECTED</span>
			<div slot="body">
				<p class="modal-p">Your listing was rejected. Would you like to revert your listing or edit the rejected one?</p>
			</div>
			<div slot="footer" class="field is-grouped">
				<div class="control">
					<a class="button is-primary" @click="revertListing()"><i class="fa fa-trash"></i>Revert</a>
				</div>
				<div class="control">
					<a class="button is-light" @click="rejectedShown = false">Edit</a>
				</div>
			</div>
		</Modal>
		<Modal v-if="modalShown" @close="modalShown = false">
			<span slot="title">Are you sure?</span>
			<div slot="body">
				<p class="modal-p">{{ modal.message }}</p>
			</div>
			<div slot="footer" class="field is-grouped">
				<div class="control">
					<a class="button is-primary" @click="modalConfirm"><i class="fa fa-check"></i>Yes</a>
				</div>
				<div class="control">
					<a class="button is-light" @click="modalShown = false">No</a>
				</div>
			</div>
		</Modal>
	</div>
</template>

<script>
	import Modal from "../Modal.vue"

	export default {
		components: {
			Modal
		},
		data() {
			return {
				errors: {
					sales_pitch: null,
					body: null,
					categories: null
				},
				user_id: null,
				modalShown: false,
				modal: {
					message: "",
					confirm: null
				},
				listing: {
					sales_pitch: "",
					body: "",
					categories: [],
				},
				changed: false,
				listings: {},
				status: "Pending",
				rejectedShown: false,
			}
		},
		methods: {
			checkForm() {
				let valid = true

				this.errors.sales_pitch = null
				if (this.listing.sales_pitch === "") {
					this.errors.sales_pitch = "Sales Pitch is required"
					valid = false
				}

				this.errors.body = null
				if (this.listing.body === "") {
					this.errors.body = "Listing Body is required"
					valid = false
				}

				this.errors.categories = null
				if (this.listing.categories.length === 0) {
					this.errors.categories = "You must select at least one category"
					valid = false
				}

				return valid
			},
			async submitForApproval() {
				if (this.checkForm()) {
					let body = this.cleanBody.replace(/<.*?>/g, "")
					this.listing.body = `<p>${body.replace(/\n/g, "</p><p>")}</p>`
					await this.$root.$data.setters.saveListing(this.$root.$data.state, this.user_id, this.listing)
					this.status = 'Pending'
					this.$notify({
						group: 'global',
						type: 'success',
						title: 'Listing Submitted',
						text: 'Your listing was submitted for Approval.',
					})
				} else {

					window.scrollTo(0,0)
				}
			},
			async modalConfirm() {
				await this.modal.confirm()
				this.modalShown = false
			},
			toggleModal(message, action) {
				this.modal.message = message
				this.modal.confirm = action
				this.modalShown = true
			},
			addCategory(e) {
				const category = parseInt(e.target.value)
				if (this.listing.categories.includes(category)) {
					e.target.checked = false
					this.changed = true
					this.listing.categories = this.listing.categories.filter((v) => v !== category)
				} else if (this.listing.categories.length < 5) {
					this.listing.categories.push(category)
					this.changed = true
				} else {
					e.target.checked = false
				}
			},
			async fixCategories() {
				if (this.listing.categories.some(item => this.spanishCategories.includes(item))) {
					this.listing.categories.push(82)
				}

				this.spanishCategories.forEach((item) => {
					if (this.listing.categories.includes(item)) {
						this.listing.categories = this.listing.categories.filter((v) => v !== item)
					}
				})
			},
			async revertListing() {
				if (this.listing.status == "Rejected") {
					await this.$root.$data.setters.deleteRejectedListing(this.$root.$data.state, this.user_id)  
					if (this.listings["Approved"]) {
						this.listing = this.listings["Approved"]
						this.status = "Approved"
					} else { this.resetListing() }
				} else if (this.listing.status == "Approved") {
					this.resetListing()
				}
				this.rejectedShown = false
				this.fixCategories()
			},
			resetListing() {
				this.listing = {
					sales_pitch: "",
					body: "",
					categories: [],
				}
				this.status = "Draft"
			}
		},
		computed: {
			cleanBody: {
				get() {
					return this.listing.body.replace(/<p>/g, "").replace(/<\/p>/g, "\n")
				},
				set(value) {
					this.listing.body = value //`<p>${value.replace(/\n/g, "</p><p>")}</p>`
					this.changed = true
				}
			},
			salesPitch: {
				get() {
					return this.listing.sales_pitch
				},
				set(value) {
					this.listing.sales_pitch = value
					this.changed = true
				}
			},
			spanishCategories() {
				return [94,95,96,97,98,99,100,101,102,103,104]
			}
		},
		async created() {
			this.user_id = JSON.parse(localStorage.getItem("user")).user_id
			this.listings = await this.$root.$data.getters.getListings(this.$root.$data.state, this.user_id)  
			if (this.listings["Rejected"]) {
				this.status = "Draft"
				this.rejectedShown = true
				this.listing = this.listings["Rejected"]
			} else if (this.listings["Pending"]) {
				this.status = "Pending"
				this.listing = this.listings["Pending"]
			} else if (this.listings["Approved"]) {
				this.status = "Approved"
				this.listing = this.listings["Approved"]
			} else {
				this.status = "Draft"	
			}

			this.fixCategories()
		}
	}
</script>